export default __webpack_public_path__ + "static/media/Prologue_Aurora1US.89ba003c.svg";